import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { Target } from 'lucide-react'

const features = [
  { name: 'Contact Information', description: 'Capture lead contact details' },
  { name: 'Source Tracking', description: 'Record where the lead came from' },
  { name: 'Initial Score', description: 'Set initial lead qualification score' },
  { name: 'Assignment', description: 'Assign lead to a team member' },
]

export default function LeadCreateView() {
  return (
    <PlaceholderPage
      title="Add Lead"
      description="Create a new sales lead"
      icon={Target}
      features={features}
      accentColor="amber"
    />
  )
}
